module.exports = __webpack_public_path__ + "static/media/move_m.ec8bdd6e.svg";